import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyJsdGettingStartedRoute: InvariantJiraRoute = {
	name: 'legacy-jsd-getting-started',
	path: '/projects/:projectKey/getting-started',
};
